import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Link,
  Box,
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { AnnouncementResponse } from '@professocialApi/professocial-core-frontend-api/models/AnnouncementResponse'

export interface AnnouncementDialogProps {
  announcement: AnnouncementResponse;
  open: boolean;
  onClose: () => void;
}

/**
 * Renders a modal dialog for the active announcement.
 *
 * @param props - Announcement dialog properties.
 */
const AnnouncementDialog: React.FC<AnnouncementDialogProps> = ({ announcement, open, onClose }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown={!announcement.ctaButtonLabel} // Block escape if there's no CTA
      BackdropProps={{ onClick: announcement.ctaButtonLabel ? undefined : (e) => e.stopPropagation() }} // Block backdrop clicks
    >
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ color: 'primary.main' }}
        >
          <InfoIcon sx={{ marginRight: 1 }} />
          <Typography variant="h6" component="span" fontWeight="bold" textAlign="center">
            {announcement.headline}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          textAlign="center"
          dangerouslySetInnerHTML={{ __html: announcement.copyText || '' }}
        />
        {announcement.linkUrl && announcement.linkText && (
          <Box textAlign="center" mt={2}>
            <Link
              href={announcement.linkUrl}
              target="_blank"
              rel="noopener"
              sx={{ fontWeight: 'bold', color: 'primary.main' }}
            >
              {announcement.linkText}
            </Link>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {announcement.ctaButtonLabel && (
          <Box width="100%" display="flex" justifyContent="center">
            <Button
              onClick={onClose}
              color="primary"
              variant="contained"
              sx={{ backgroundColor: 'primary.main' }}
            >
              {announcement.ctaButtonLabel}
            </Button>
          </Box>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default AnnouncementDialog
